import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Html from 'react-pdf-html';
import { config } from 'src/config';
import { useAppSelector } from 'src/rtk/app/hook';

interface Props {
  traineeData: any;
  setReportId: any;
}
// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
  },
  nextLine: {
    marginTop: -20,
    textAlign: 'center',
    fontSize: '10px',
  },
});

// Create Document Component
// const MyDocument = () => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <View style={styles.section}>
//         <Text>Section #1</Text>
//       </View>
//       <View style={styles.section}>
//         <Text>Section #2</Text>
//       </View>
//     </Page>
//   </Document>
// );

export const InterviewReportPDF = (props: Props) => {
  const { traineeData, setReportId } = props;
  console.log(traineeData)

  const token = useAppSelector((state) => state.auth.token);

  const [internalExaminerSignatureImageBase64, setInternalExaminerSignatureImageBase64] = useState('');
  const [externalExaminerSignatureImageBase64, setExternalExaminerSignatureImageBase64] = useState('');
  const [itmcMemberSignatureImageBase64, setItmcMemberSignatureImageBase64] = useState('');

  const fetchImageBase64 = async (filepath: string) => {
    const res = await fetch(`${config.API_URL}/v1/get-image?filepath=${filepath}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`, // if needed
        'Accept': 'image/*',                    // optional
      },
    });

    const blob = await res.blob();
    const reader = new FileReader();

    return await new Promise<string>((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const getMarks = (assessmentValue: number) => {
    switch (assessmentValue) {
      case 1:
        return 'Poor';
      case 2:
        return 'Good';
      case 3:
        return 'Excellent';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (traineeData?.assessments[0]?.assessor_info?.details?.personal_info?.signature) {
      fetchImageBase64(traineeData?.assessments[0]?.assessor_info?.details?.personal_info?.signature?.replace(/^storage\//, "")).then((base64) => {
        setInternalExaminerSignatureImageBase64(base64);
      });
    }
    if (traineeData?.assessments[1]?.assessor_info?.details?.personal_info?.signature) {
      fetchImageBase64(traineeData?.assessments[1]?.assessor_info?.details?.personal_info?.signature?.replace(/^storage\//, "")).then((base64) => {
        setExternalExaminerSignatureImageBase64(base64);
      });
    }
    if (traineeData?.itmc_info?.details?.personal_info?.signature) {
      fetchImageBase64(traineeData?.itmc_info?.details?.personal_info?.signature?.replace(/^storage\//, "")).then((base64) => {
        setItmcMemberSignatureImageBase64(base64);
      });
    }
  }, [traineeData?.assessments[1]?.assessor_info?.details?.personal_info?.signature, traineeData?.assessments[0]?.assessor_info?.details?.personal_info?.signature, traineeData?.itmc_info?.details?.personal_info?.signature]);


  const html = `
    <html>
      <body>
        <style>
          .print-container{
            padding: 0 15px;
        }

          .wide-column {
            width: 500px;
            background-color: powderblue;
          }

          table {
            margin: 3px 0px;
            padding: 0px;
            border: 1px solid black;
            font-size: 12px;
          }
          p{
            font - size: 14px;
            margin: 10px 0px;
          }
          table > tbody> tr > *{
            padding: 4.5px
          }

          table th {
            text-align: center;    
          }

          table td {

          }

          .bgColor {
            background-color: powderblue;
          }

          b {
            font-family: 'Times-Bold'; 
          }

          .signature-box {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 10px;
            padding: 0 10px;
          }

          .assessment-section {
            padding: 0 10px;
          }

          .header-section {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
          }

          .assessment-by{
            font-weight: bold;
            text-align: center;
            font-size: 12px;
            background-color: #f0f0f0;
          }

          .case-text {
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 14px;
          }
            
        </style>

        <div class="print-container">
          <div class="header-section">
            <div>
              <div>
                Name of the candidate: <b>${traineeData?.registration?.personal_info?.full_name || ''}</b>
              </div>
              <div>
                Name of the Assessors: <b>${traineeData?.assessments[0]?.assessor_info?.details?.personal_info?.full_name || ''}, ${traineeData?.assessments[1]?.assessor_info?.details?.personal_info?.full_name || ''}</b>
              </div>
            </div>
            <div>
              <div>
                Date: <b>${moment(traineeData?.progress_report_interview?.interview_date).format('DD-MMM-YYYY') || ''}</b>
              </div>
              <div>
                Reg No: <b>${traineeData?.registration?.bmdc_registration_no || ''}</b>
              </div>
              <div>
                Subject: <b>${traineeData?.registration?.subject?.subject_name || ''}</b>
              </div>
            </div>
          </div>
          <div>
            ${traineeData?.assessments?.map((assessment: any, index: number) => (
            `<div key=${assessment.id}>
                  <div class='assessment-by'>Assessment by ${assessment?.assessor_info?.details?.personal_info?.full_name}</div>
                  <p class='case-text'>Recent Seen Case(Cold)</p>
                  <table>
                    <thead>
                      <tr>
                        <th>Case</th>
                        <th>Value</th>
                        <th>Result</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Point of History</td>
                        <td>${assessment?.point_in_history || ''}</td>
                        <td>${getMarks(assessment?.point_in_history_assessment)}</td>
                      </tr>
                      <tr>
                        <td>Point of Examination</td>
                        <td>${assessment?.point_in_examination || ''}</td>
                        <td>${getMarks(assessment?.point_in_examination_assessment)}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p class='case-text'>Emergency Managed</p>
                  <table>
                    <thead>
                      <tr>
                        <th>Case</th>
                        <th>Value</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Problem</td>
                        <td>${assessment?.problem || ''}</td>
                        <td>${getMarks(assessment?.problem_assessment)}</td>
                      </tr>
                      <tr>
                        <td>How Managed</td>
                        <td>${assessment?.how_managed || ''}</td>
                        <td>${getMarks(assessment?.how_managed_assessment)}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p class='case-text'>Procedure</p>
                  <table>
                    <thead>
                      <tr>
                        <th>Case</th>
                        <th>Value</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Why Done</td>
                        <td>${assessment?.why_done || ''}</td>
                        <td>${getMarks(assessment?.why_done_assessment)}</td>
                      </tr>
                      <tr>
                        <td>How Done</td>
                        <td>${assessment?.how_done || ''}</td>
                        <td>${getMarks(assessment?.how_done_assessment)}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>`
              )).join('')}
          </div>
          <div class="signature-box">
            <div>
              <label style="font-size: 12;">Signature of the Assessor</label>
              <span>
                <img src="${internalExaminerSignatureImageBase64}" style="width: 120px; height: 25px; margin-bottom: 5px;" />
                <img src="${externalExaminerSignatureImageBase64}" style="width: 120px; height: 25px; margin-bottom: 0px;" />
              </span>
            </div>
            
            <div>
              <label style="font-size: 12;">Signature of the ITMC Member</label>
              <img src="${itmcMemberSignatureImageBase64}" style="width: 120px; height: 25px; margin-bottom: 0px;" />
            </div>
          </div>
          
        </div>
      </body>
    </html>
  `;

  // const MyDocument = (
  //   <Document>
  //     <Page size="A4" style={styles.page}>
  //       <View style={styles.section}>
  //         <Text>Section #1</Text>
  //       </View>
  //       <View style={styles.section}>
  //         <Text>Section #2</Text>
  //       </View>
  //     </Page>
  //   </Document>
  // );

  const MyDocument = (
    <Document>
      <Page size="A4">
        <View style={styles.row}>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '10px',
            }}
          />
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '14px',
              margin: '20px',
              marginBottom: '0px',
            }}
          >
            BANGLADESH COLLEGE OF PHYSICIANS AND SURGEONS (BCPS)
          </Text>
        </View>
        <Text style={styles.nextLine}>
          67, Shaheed Tajuddin Ahmed Sarani, Mohakhali, Dhaka-1212
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica',
            fontSize: '14px',
            margin: '5px',
          }}
        >
          Assessment: Training Progress Report Interview
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica-Bold',
            fontSize: '10px',
          }}
        >
          Name of Institute: {traineeData?.registration?.current_session_and_supervisor_info?.supervisor?.institute_name || ''}
        </Text>
        <Html>{html}</Html>
      </Page>
    </Document>
  );

  useEffect(() => {
    if (traineeData && internalExaminerSignatureImageBase64 && externalExaminerSignatureImageBase64 && itmcMemberSignatureImageBase64) {
      const pdfData = pdf(MyDocument).toBlob();
      pdfData.then((pdfData) => {
        const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfContent);
        setReportId('');
        window.open(url, '_blank');
      });
    }
  }, [traineeData, setReportId, internalExaminerSignatureImageBase64, externalExaminerSignatureImageBase64, itmcMemberSignatureImageBase64]);


  return (
    <div>
      {/* {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null} */}
    </div>
  );
};
